<template>
  <div id="zgdetail">
    <div class="cover" id="gcover">
      <swiper :options="swiperOption">
        <!-- slides -->
        <swiper-slide v-for="(n,index) in 3" :key="index" :style="{height:cover_height+'px'}">
          <img class="noevents-img" src="../../assets/blankimgcover.jpg" />
        </swiper-slide>
      </swiper>
    </div>

    <!--显示秒杀商品-->
    <div class="relativeItem">
      <img src="../../assets/zshop/zdet.jpg" />
      <div class="timediv absoluteItem">
        <p class="p1 flex-box">
          <span class="s1">
            <i :style="{width:timepro}"></i>
          </span>
          <span>已抢{{ timepro }}</span>
        </p>
        <p class="p2 flex-box">
          <span class="s1">距离结束还有</span>
          <span class="s2">17:03:05</span>
        </p>
      </div>
    </div>

    <div class="bottom">
      <!--商品价格-->
      <div class="price">
        <span class="pri">
          <i>￥</i>198.00
        </span>
        <span class="opri">
          原价
          <i>￥288.00</i>
        </span>
      </div>
      <div class="g-name">
        EltaMD 氨基酸清洗毛孔卸妆泡沫洁面乳温
        和洗面奶慕斯女 男用207ml
      </div>
      <div class="bei flex-box">
        <p>快递&nbsp;免运费</p>
        <p>月售&nbsp;299&nbsp;件</p>
        <p>重庆武隆</p>
      </div>
      <!--服务-->
      <div class="serv flex-box arrow relativeItem">
        <a class="allA" @click="show_serv_tc = true"></a>
        <p class="le">服务</p>
        <p class="ri flex-box">
          <span v-for="(n,index) in 3" :key="index">
            原装正品
            <i>当前商品不支持退款</i>
          </span>
        </p>
      </div>

      <!--商品评价-->
      <div class="com" id="gcomp">
        <p class="tit relativeItem arrow flex-box">
          <span class="ti">
            商品贫家
            <i>1209条评价</i>
          </span>
          <router-link class="all" to="/zallcomp">查看全部</router-link>
        </p>
        <ul class="clist">
          <li>
            <div class="c-t flex-box">
              <div class="img relativeItem">
                <img class="absoluteItem centerImg" src="../../assets/blankimgcover.jpg" />
              </div>
              <div class="ri">
                <p class="p1">红字残白</p>
                <p class="p2">2019-12-02</p>
              </div>
            </div>
            <div class="text">这卸妆泡沫也太好看用了吧，我要推荐给我的小 姐妹，哈哈哈！</div>
          </li>
        </ul>
      </div>
    </div>

    <!--商品详情-->
    <div class="detail" id="gdetail">
      <div class="title">
        <span class="relativeItem">商品详情</span>
      </div>
      <div class="main">
        <img src="../../assets/blankimgcover.jpg" />
        <img src="../../assets/blankimgcover.jpg" />
        <img src="../../assets/blankimgcover.jpg" />
      </div>
    </div>

    <!--下单按钮-->
    <div class="button flex-box">
      <div class="le flex-box">
        <a href="tel:400-0238896">
          <img src="../../assets/zshop/zdet(2).png" />
          客服
        </a>
        <a href="tel:400-0238896">
          <img src="../../assets/zshop/zdet(1).png" />
          <img src="../../assets/zshop/zdet(4).png" />
          想买
        </a>
      </div>
      <button class="ri commonBk">立即购买</button>
    </div>

    <!--服务详细说明-->
    <div class="tc servtc" v-if="show_serv_tc" @click="show_serv_tc = false">
      <div class="main absoluteItem" @click.stop>
        <h3>服务</h3>
        <ul class="servlist">
          <li v-for="(n,index) in 8" :key="index">
            <p class="p1">原装正品</p>
            <p class="p2">保证每一件商品都是原装正品，杜绝一切假货，让您 放心购物。</p>
          </li>
        </ul>
        <button class="absoluteItem centerX" @click="show_serv_tc = false">完成</button>
      </div>
    </div>

    <!--顶部导航-->
    <div class="topnav" :style="{opacity:nav_opacity,display:nav_display}">
      <span :class="{act:nav === 0}" @click="scroll_top('gcover',0)">商品</span>
      <span :class="{act:nav === 1}" @click="scroll_top('gcomp',1)">评价</span>
      <span :class="{act:nav === 2}" @click="scroll_top('gdetail',2)">详情</span>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
// import { scrollAnimation } from "../../utils/scroll.js";

export default {
  name: "zgdetail",
  components: {
    swiper,
    swiperSlide
  },
  data() {
    return {
      nav_display: "none",
      nav_opacity: 0, //顶部导航栏设置透明度
      nav: 0, //顶部导航定位
      timepro: "50%", //秒杀商品的进度条
      show_serv_tc: false, //是否显示服务弹窗
      swiperOption: {
        speed: 500,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false
        },
        loop: true,
        self: this,
        centeredSlides: true
      },
      cover_height: 0
    };
  },
  methods: {
    /**滚动到指定位置 */
    scroll_top(idname, num) {
      this.nav = num;
      // let item_scrolltop = document.getElementById(idname).offsetTop;
      // scrollAnimation(window.scrollY, item_scrolltop);
      let top = document.getElementById(idname).offsetTop;
      if (idname !== 'gcover') {
        window.scrollTo(0,top-60)
      }else{
        window.scrollTo(0,top)
      }
      
    },
    /**计算banner的高度和宽度一致 */
    set_cover_height() {
      let w = document.body.clientWidth;
      this.cover_height = w;
    },
    /**页面滚动设置顶部导航 */
    scroll_func() {
      let _this = this;
      let cover = document.getElementById("gcover"),
        gcomp = document.getElementById("gcomp"),
        gdetail = document.getElementById("gdetail");
      let top = null;
      window.onscroll = function() {
        top = window.scrollY;
        _this.nav_opacity = top * 0.005;
        if (_this.nav_opacity == 0) {
          _this.nav_display = "none";
        } else {
          _this.nav_display = "block";
        }
        if (_this.nav_opacity > 1) {
          _this.nav_opacity = 1;
        }

        if (top > cover.offsetTop && top < gcomp.offsetTop) {
          _this.nav = 0;
        }
        if (top >= gcomp.offsetTop-60 && top < gdetail.offsetTop) {
          _this.nav = 1;
        }
        if (top >= gdetail.offsetTop-60) {
          _this.nav = 2;
        }
      };
    }
  },
  mounted: function() {
    this.$tool.setTitle("商品详情");
    this.set_cover_height();
    this.scroll_func();
  },
  watch: {}
};
</script>








<style scoped>
#zgdetail {
  background: white;
}
/**banner之下 */
/**商品价格 */
.bottom {
  padding: 0 16px;
}
.price {
  padding: 15px 0;
}
.price .pri {
  font-size: 22px;
  color: #ff6161;
  margin-right: 15px;
  font-weight: bold;
}
.price i {
  font-style: normal;
  font-size: 14px;
}
.price .opri {
  font-size: 14px;
  color: #999;
}
.price .opri i {
  text-decoration: line-through;
}
.name {
  font-size: 18px;
  text-align: justify;
}
.bei {
  justify-content: space-between;
  font-size: 14px;
  color: #999;
  margin: 15px 0;
}

/**服务 */
.serv {
  font-size: 14px;
  margin-bottom: 15px;
  padding-top: 15px;
}
.serv .le {
  color: #999;
  width: 12%;
}
.serv .ri {
  align-items: center;
  flex-wrap: wrap;
  width: 88%;
}
.serv::after {
  top: 22%;
  right: 0 !important;
  transform: rotateZ(45deg);
}
.serv span {
  background: url("../../assets/zshop/zdet(3).png") no-repeat left center;
  background-size: 13px 13px;
  padding-left: 15px;
  margin-right: 12px;
  margin-bottom: 7px;
}
.serv i {
  font-style: normal;
  color: #999;
  margin-left: 12px;
}

/**商品评价 */
.tit {
  justify-content: space-between;
}
.tit .ti {
  font-size: 16px;
}
.tit i {
  font-style: normal;
  font-size: 12px;
  color: #999;
}
.tit .all {
  font-style: 12px;
  color: #ff6161;
  margin-right: 16px;
}
.tit::after {
  right: 0;
}

/**评论 */
.c-t {
  align-items: center;
}
.c-t .img {
  width: 37px;
  height: 37px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 12px;
}
.c-t .p1 {
  font-size: 14px;
  margin-bottom: 3px;
}
.c-t .p2 {
  font-size: 11px;
  color: #999;
}
.clist .text {
  font-size: 16px;
  text-align: justify;
  margin-top: 12px;
  color: #999;
}
.clist li {
  margin-bottom: 18px;
}
.clist {
  margin-top: 24px;
  margin-bottom: 6px;
}

/**商品详情 */
.detail .title {
  text-align: center;
  font-size: 17px;
  margin-top: 22px;
  margin-bottom: 17px;
}
.detail .title span::after,
.detail .title span::before {
  position: absolute;
  content: "";
  width: 49px;
  height: 9px;
  background: url("../../assets/zshop/zdet.png") no-repeat left center;
  background-size: 100%;
  top: 50%;
  transform: translateY(-27%);
}
.detail .title span::before {
  right: 115%;
}
.detail .title span::after {
  left: 115%;
  transform: translateY(-27%) rotateZ(180deg);
}
.detail .main img {
  display: block;
}
.detail {
  padding-bottom: 60px;
}

/**下单 */
.button {
  position: fixed;
  width: 100%;
  z-index: 1;
  bottom: 0;
  left: 0;
  justify-content: space-between;
  padding: 5px 16px 5px 0;
  background: white;
}
.button button {
  font-size: 13px;
  color: white;
  padding: 11px 0;
  border-radius: 3rem;
  width: 55%;
}
.button a {
  width: 64px;
  font-size: 11px;
  text-align: center;
}
.button img {
  display: block;
  width: 20px;
  margin: 0 auto;
  margin-bottom: 2px;
}

/**服务 */
.servtc .main {
  padding: 16px;
  padding-top: 20px;
  width: 100%;
  height: 70%;
  bottom: 0;
  left: 0;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: white;
}
.servtc h3 {
  font-size: 17px;
  text-align: center;
  margin-bottom: 16px;
}
.servtc ul {
  max-height: 80%;
  overflow-y: scroll;
  margin-bottom: 50px;
}
.servtc li {
  font-size: 14px;
  margin-top: 16px;
  padding-bottom: 16px;
  padding-left: 21px;
  background: url("../../assets/zshop/zdet(3).png") no-repeat left 3px;
  background-size: 13px 13px;
  margin-bottom: 5px;
}
.servtc li:first-child {
  margin-top: 0;
}
.servtc .p2 {
  color: #999;
}
.servtc button {
  bottom: 5px;
  width: 92%;
  height: 38px;
  line-height: 38px;
  color: white;
  font-size: 13px;
  background: #a816ff;
  border-radius: 3rem;
}

/**秒杀商品显示 */
.timediv {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding-top: 7px;
  padding-right: 16px;
}
.timediv p {
  justify-content: flex-end;
  align-items: center;
}
.timediv .p1 {
  font-size: 10px;
  color: #fffe3d;
  margin-bottom: 1px;
}
.timediv .p1 .s1 {
  position: relative;
  width: 66px;
  height: 5px;
  border-radius: 3rem;
  background: #ffad97;
  box-shadow: 0 1px 3px rgba(255, 173, 151, 0.2);
  margin-right: 10px;
}
.timediv .p1 i {
  position: absolute;
  height: 100%;
  left: 0;
  top: 0;
  background: #fffe3d;
  border-radius: 3rem;
}
.timediv .p2 .s1 {
  font-size: 11px;
  margin-right: 15px;
  color: white;
}
.timediv .p2 .s2 {
  font-size: 14px;
  color: #fffe3d;
}

/**顶部导航 */
.topnav {
  position: fixed;
  padding: 10px 0;
  top: 0;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 13px;
  background: white;
  z-index: 2;
}
.topnav span {
  margin: 9px;
}
.topnav .act {
  font-size: 18px;
}
</style>
